// extracted by mini-css-extract-plugin
export default {"loaderDiv":"Loader_loaderDiv__CFYQb","spin":"Loader_spin__I0Tfd"};